import { useState, useContext } from "react";
import CheckUpContext from "../../context/check-up";
import AppError from "../app-error";
import Title from "../title";
import CheckUpDetail from "./check-up-detail";
import CheckUpContent from "./check-up-content";
import CheckUpSurvey from "./check-up-survey";
import dayjs from "dayjs";
import CheckUpSubmitRequestModal from "./check-up-submit-request-modal";

const CheckUpBody = () => {
  const {
    labels,
    error,
    checkUpInfo,
    navigation,
    path,
    setNavigation,
    currentRequest,
    setCurrentRequest,
    status,
    isFetching,
    appLang,
    nextCheckupDate,
  } = useContext(CheckUpContext);

  const [discardModal, setDiscardModal] = useState(false);
  const [submitModal, setSubmitModal] = useState(false);
  //console.log("NAVIGATION", navigation, "STATUS", status, "CURRENT-REQUEST", currentRequest);

  const handleSendRequest = () => setSubmitModal(true);

  return error ? (
    <AppError labels={labels} error={error} />
  ) : isFetching ? (
    <div className="loading-spinner mt" />
  ) : (
    <>
      <Title
        description={
          ["DRAFT", "SENT", "IN_PROGRESS"].includes(currentRequest?.status) || navigation
            ? null
            : {
                "ready-to-book":
                  labels?.WELFARE_CHECKUP_BOOKING_DESCRIPTION_BANNER ||
                  "Welfare EssilorLuxottica offre la possibilità di effettuare un check-up medico completo e gratuito presso strutture mediche convenzionate presenti nei nostri territori.",
                closed: (
                  labels?.WELFARE_CHECKUP_NEXT_BOOKING_DATE ||
                  "<strong>Prossimo check-up previsto dal: [DATE]</strong>"
                ).replace(
                  "[DATE]",
                  dayjs(Number(nextCheckupDate)).locale(appLang?.value).format("L")
                ),
              }[status]
        }
        button={
          navigation
            ? []
            : status === "closed"
            ? []
            : currentRequest
            ? currentRequest?.status === "DRAFT"
              ? [
                  {
                    action: () => {
                      setNavigation("detail");
                    },
                    label: labels?.EDIT || "Edit",
                    icon: "pencil",
                    className: "link app__title-cta",
                    center: true,
                  },
                  {
                    action: handleSendRequest,
                    disabled: currentRequest?.lastCompletedStep !== 2,
                    label: labels?.SEND_REQUEST || "Send request",
                    className: "button app__title-button",
                  },
                ]
              : ["COMPLETED", "CANCELED"].includes(currentRequest?.status)
              ? []
              : [
                  {
                    action: () => setNavigation("detail"),
                    label: labels?.VIEW_DETAIL || "Vedi dettaglio",
                    icon: "angle-down",
                    className: "link app__title-cta",
                    center: true,
                  },
                ]
            : [
                ...(checkUpInfo
                  ? [
                      {
                        action: () => setNavigation("info"),
                        label: labels?.WELFARE_CHECKUP_READ_MORE || "Scopri di più",
                        icon: "angle-down",
                        link: true,
                      },
                    ]
                  : []),
                {
                  action: () => {
                    setCurrentRequest("new");
                    setNavigation("detail");
                  },
                  label: labels?.WELFARE_CHECKUP_BOOKING_CTA || "Prenota il checkup",
                  className: "button app__title-button",
                },
              ]
        }
        showStepper={
          navigation === "detail" &&
          (currentRequest === "new" || currentRequest?.status === "DRAFT")
        }
        stepper={{
          sections: {
            "ready-to-book":
              currentRequest === "new" || currentRequest?.status === "DRAFT" ? [0, 1, 2, 3] : null,
          }[status],
          currentSectionIndex: path?.length - 1,
        }}
        handleNavigation={
          {
            info: () => setNavigation(null),
            detail:
              currentRequest === "new" || currentRequest?.status === "DRAFT"
                ? () => setDiscardModal(true)
                : ["SENT", "IN_PROGRESS"].includes(currentRequest?.status)
                ? () => setNavigation(null)
                : () => {
                    setCurrentRequest();
                    setNavigation(null);
                  },
          }[navigation]
        }
        handleSticky={true}
      >
        {{
          info: checkUpInfo?.title || "Check-up sanitario",
          detail:
            {
              SENT:
                labels?.WELFARE_CHECKUP_BOOKING_SENT_DETAIL_TITLE_BANNER ||
                "Prenotazione check-up sanitario: inviata",
              IN_PROGRESS:
                labels?.WELFARE_CHECKUP_BOOKING_CONFIRMED_DETAIL_TITLE_BANNER ||
                "Prenotazione check-up sanitario: confermata",
              COMPLETED: (
                labels?.WELFARE_CHECKUP_BOOKING_COMPLETED_DETAIL_TITLE_BANNER ||
                "Check-up sanitario completato il [DATE]"
              ).replace(
                "[DATE]",
                dayjs(Number(currentRequest?.completionDate)).locale(appLang?.value).format("L")
              ),
              CANCELED:
                labels?.WELFARE_CHECKUP_BOOKING_CANCELED_DETAIL_TITLE_BANNER ||
                "Prenotazione check-up sanitario: cancellato",
            }[currentRequest?.status] ||
            labels?.WELFARE_CHECKUP_BOOKING_TITLE_BANNER ||
            "Prenotazione check-up sanitario",
        }[navigation] ||
          {
            closed:
              labels?.WELFARE_CHECKUP_COMPLETED_TITLE_BANNER ||
              "Il tuo check-up risulta completato",
            "ready-to-book": currentRequest
              ? {
                  DRAFT:
                    labels?.WELFARE_CHECKUP_BOOKING_DRAFT_TITLE_BANNER ||
                    "La tua prenotazione è in bozza",
                  SENT:
                    labels?.WELFARE_CHECKUP_BOOKING_SENT_TITLE_BANNER ||
                    "La tua prenotazione è inviata",
                  IN_PROGRESS:
                    labels?.WELFARE_CHECKUP_BOOKING_CONFIRMED_TITLE_BANNER ||
                    "La tua prenotazione risulta confermata",
                  COMPLETED:
                    labels?.WELFARE_CHECKUP_BOOKING_COMPLETED_TITLE_BANNRR ||
                    "Il tuo check-up risulta completato",
                }[currentRequest?.status]
              : labels?.WELFARE_CHECKUP_READY_TO_BOOK_TITLE_BANNER ||
                "E' ora di prenotare il tuo check-up annuale",
          }[status]}
      </Title>
      {navigation === "info" ? (
        <CheckUpDetail data={checkUpInfo} />
      ) : navigation === "detail" ? (
        <CheckUpSurvey discardModal={discardModal} setDiscardModal={setDiscardModal} />
      ) : (
        <CheckUpContent />
      )}
      <CheckUpSubmitRequestModal
        show={submitModal}
        closeModal={() => setSubmitModal(false)}
        key={`submit-${!!submitModal}`}
      />
    </>
  );
};

export default CheckUpBody;
